<template>
  <div class="featured-news-wrapper">
    <!-- Download Data Banner (mobile)-->
    <div class="download-data-banner d-block d-lg-none">
      <p
        class="download-data-banner-title"
      >Download realtime and historical data for stock market, news, economic, forex, crypto, futures, and commodities.</p>
      <p class="download-data-banner-link">
        Visit API Documentation here:
        <router-link to="/api/docs/V2.0/introduction">unibit.ai/api/docs</router-link>
      </p>
    </div>

    <!-- featured news section -->
    <pulse-loader
      v-if="loading"
      :loading="loading"
      color="#F5A623"
      size="1.5rem"
      style="margin:5rem auto;text-align:center"
    ></pulse-loader>

    <div v-if="!loading && !errorLoading" class="featured-section-content row">
      <div class="featured-section col-lg-9 col-xl-10">
        <div class="featured-section-header">
          <h2>Featured News</h2>

          <span
            class="download-link"
            data-toggle="download-featured-news-tooltip"
            data-placement="bottom"
            title="click to download featured news sample"
            tabindex="0"
            @click="openLoginModal"
          >Download Sample Data</span>
        </div>
        <div v-for="(news, index) in featuredNewsData" :key="index" class="row news-article">
          <div v-if="!isLogin" class="col-md-3 news-stats" @click="openLoginModal">
            <p>
              Sentiment Score:
              <v-icon name="lock"></v-icon>
            </p>
            <p>
              Classification:
              <v-icon name="lock"></v-icon>
            </p>
            <p>
              Name Entity:
              <v-icon name="lock"></v-icon>
            </p>
          </div>
          <div v-else class="col-md-3 news-stats">
            <p>
              Sentiment Score:
              <span>{{news.sentiment ? news.sentiment : "-"}}</span>
            </p>
            <p>
              Classification:
              <span>{{getNewsClassification(news)}}</span>
            </p>
            <p>
              Name Entity:
              <span>{{getNewsEntity(news)}}</span>
            </p>
          </div>

          <div class="col-md-9 news-content">
            <p class="news-source">
              <span>{{checkNewsParam(news.source) | shorten(20)}}</span>&nbsp;
              <span>({{checkNewsParam(news.author) | shorten(20)}})</span>&nbsp;
              <a
                :href="news.url ? news.url: ''"
                class="news-outlink"
                target="_blank"
                rel="noopener noreferrer"
              >
                <v-icon name="external-link"></v-icon>
              </a>
            </p>
            <p class="news-title">
              {{checkNewsParam(news.title) | shorten(120) }}
              <span
                class="news-ticker"
                @click="setSearchTicker(news.ticker)"
              >({{news.ticker}})</span>
            </p>
            <p class="news-description">{{checkNewsParam(news.description) | shorten(300)}}</p>

            <p class="news-datetime">{{news['publish at'] ? news['publish at'].split("T")[0] : ""}}</p>
          </div>
        </div>
        <div class="footer-link">
          <pulse-loader
            v-if="loadMore"
            :loading="loadMore"
            color="#F5A623"
            size="1.5rem"
            style="margin:1rem auto;text-align:center"
          ></pulse-loader>

          <p v-else class="text-center" @click="showMoreNews">
            <button v-if="!noMoreFeaturedNews" class="load-more-button">
              Load More
              <v-icon name="arrow-down"></v-icon>
            </button>
            <span v-else style="color:#007bff">
              <router-link
                to="/api/docs/V2.0/stock_news"
              >Please check out our News API for more information.</router-link>
            </span>
          </p>
        </div>
      </div>

      <aside class="download-data-aside-wrapper col-lg-3 col-xl-2 d-none d-lg-block">
        <div class="download-data-aside">
          <p
            class="download-data-aside-title d-block d-xl-none"
          >Download realtime and historical data for stock market, news, economic, forex, crypto, futures, and commodities.</p>
          <div class="download-data-aside-title d-none d-xl-block">
            Download realtime and historical data for:
            <ul>
              <li>stock market</li>
              <li>news</li>
              <li>economic</li>
              <li>forex</li>
              <li>crypto</li>
              <li>futures</li>
              <li>commodities</li>
            </ul>
          </div>
          <p class="download-data-aside-link">
            Visit API Documentation here:
            <router-link to="/api/docs/V2.0/introduction">unibit.ai/api/docs</router-link>
          </p>
        </div>
      </aside>
    </div>

    <div
      v-if="errorLoading"
      class="error-loading row"
    >Oops, news will be back shortly. Please try again later...</div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "FeaturedNews",

  components: {
    PulseLoader
  },

  computed: {
    ...mapGetters(["isLogin"]),

    ...mapState({
      maxFeaturedNewsPage: state => state.PageService.maxFeaturedNewsPage,
      currentFeaturedNewsPage: state =>
        state.PageService.currentFeaturedNewsPage,
      featuredNewsData: state => state.PageService.featuredNewsData,
      apikey: state => state.UserService.apikey
    })
  },

  data() {
    return {
      loading: true,
      errorLoading: false,
      loadMore: false,
      noMoreFeaturedNews: false
    };
  },

  mounted() {
    // get FeaturedNews
    console.log(
      "[featured-news] mounted() featuredNewsData is: ",
      this.featuredNewsData
    );
    if (this.featuredNewsData.length == 0) {
      this.getFeaturedNews();
    } else {
      this.loading = false;
    }
  },

  updated() {
    $('[data-toggle="download-featured-news-tooltip"]').tooltip();
  },

  methods: {
    getFeaturedNews() {
      this.loading = true;
      this.errorLoading = false;
      this.$store
        .dispatch("getFeaturedNews")
        .then(res => {
          this.$store.commit("setFeaturedNewsData", res.data);
          console.log("get featured news...", res.data);
          this.loading = false;
        })
        .catch(err => {
          console.log("getFeaturedNews() ERROR: ", err);
          this.loading = false;
          this.errorLoading = true;
        });
    },

    getNewsClassification(news) {
      const genre = news["event genre"] ? news["event genre"] : [];
      const sector = news["event sector"] ? news["event sector"] : [];
      const classification = [...genre, ...sector];
      return classification.length ? classification.join(", ") : "-";
    },

    getNewsEntity(news) {
      const location = news["event location"] ? news["event location"] : [];
      const person = news["event person"] ? news["event person"] : [];
      const organiation = news["event organization"]
        ? news["event organization"]
        : [];
      const entities = [...location, ...person, ...organiation];
      return entities.length ? entities.join(", ") : "-";
    },

    // mergeSameTitleNews(newslist) {
    //   let groupedNews = groupBy(newslist, "title");

    //   let resMergedNewsList = [];
    //   for (let [title, newsArr] of Object.entries(groupedNews)) {
    //     const tickers = newsArr.map(el => el.ticker);
    //     newsArr[0].tickers = [...new Set(tickers)];
    //     resMergedNewsList.push(newsArr[0]);
    //   }
    //   console.log("resMergedNewsList is: ", resMergedNewsList);

    //   return resMergedNewsList;
    // },

    showMoreNews() {
      if (this.isLogin) {
        this.loadMore = true;
        if (this.currentFeaturedNewsPage < this.maxFeaturedNewsPage) {
          this.$store.commit(
            "setCurrentFeaturedNewsPage",
            this.currentFeaturedNewsPage + 1
          );
          this.$store
            .dispatch("getFeaturedNews")
            .then(res => {
              if (res.data && res.data.length > 0) {
                this.$store.commit(
                  "setFeaturedNewsData",
                  this.featuredNewsData.concat(res.data)
                );
                console.log("get more featured news...", res.data);
              }
              this.loadMore = false;
            })
            .catch(err => {
              console.log("getFeaturedNews() ERROR: ", err);
              this.loadMore = false;
            });
        } else {
          // current page reached max request limit
          this.noMoreFeaturedNews = true;
          this.loadMore = false;
        }
      } else {
        $("#GetFreeApiModal").modal("show");
      }
    },

    setSearchTicker(ticker) {
      // elastic search ticker
      this.$store
        .dispatch("elaticSearchForAssets", ticker)
        .then(res => res.json())
        .then(res => {
          // put the results which name equals search name in the first row
          let equal = res.filter(
            el => el.ticker.toLowerCase() === ticker.toLowerCase()
          )[0];
          return equal;
        })
        .then(equalInfo => {
          console.log(
            "[featured-news] setSearchTicker() equalInfo is: ",
            equalInfo
          );
          this.$store.commit("setAssetInfo", {
            ticker: equalInfo.ticker,
            name: equalInfo.companyName,
            exchange: equalInfo.exchange
          });
          return equalInfo.ticker;
        })
        .then(ticker => {
          this.$router.push("/insight/company/tearsheet/" + ticker);
        })
        .catch(err => {
          console.log("setSearchTicker() ERROR is: ", err);
        });
    },

    openLoginModal() {
      if (!this.isLogin) {
        $("#GetFreeApiModal").modal("show");
      } else {
        this.$store.dispatch("getFeaturedNews", this.apikey).then(
          res => {
            console.log("[Featured News Download Sample Data](Success):", res);
            this.exportToCsv("featured_news.csv", res.data);
            mixpanel.track("download sample data", {
              type: "featured-news"
            });
          },
          err => {
            console.log("[Featured News Download Sample Data]:", err);
          }
        );
      }
    },

    checkNewsParam(param) {
      return param ? param : "";
    }
  }
};
</script>

<style scoped>
.featured-news-wrapper {
  min-height: 4rem;
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.download-link {
  color: #f5a623 !important;
  font-weight: bold;
  font-family: Avenir;
  font-size: 0.9rem;
  color: black;
  margin: 0 0.35rem;
  cursor: pointer;
}

.download-link:focus {
  outline: none;
}

/* download data banner styling (mobile) */

.download-data-banner {
  border: 1px solid #16abbd;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
}

.download-data-banner-title {
  font-size: 0.8rem;
}

.download-data-banner-link {
  font-size: 0.8rem;
  font-weight: bold;
}

/* opinion article styling */

.featured-section-content {
  padding: 1rem;
}

.featured-section-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.featured-section-header > h2 {
  font-family: Raleway;
  font-weight: bold;
  font-size: 0.9rem;
}

.featured-section-header > span {
  color: #f5a623;
  font-weight: bold;
  cursor: pointer;
}

.featured-section-header > span:focus {
  outline: none;
}

.icon-chevron-right {
  width: 1rem;
  height: 100%;
  padding-bottom: 0.25rem;
  float: right;
  color: #f5a623;
  opacity: 0.5;
}

.opinion-research {
  margin-bottom: 2rem;
}

.opinion-research-img {
  text-align: center;
}

.opinion-research-img > img {
  width: 100%;
  max-height: 14rem;
  object-fit: cover;
  overflow: hidden;
}

.opinion-publish-date {
  font-family: avenir;
  font-size: 0.725rem;
  font-weight: bold;
  color: #a4a4a4;
  margin-top: 0.5rem;
}

.opinion-title {
  font-family: Raleway;
  font-weight: bold;
  font-size: 0.9rem;
  margin-top: 0.1rem;
  margin-bottom: 0.2rem;
}

.opinion-description {
  font-family: avenir;
  font-size: 0.9rem;
}

.opinion-description > a {
  font-weight: bold;
}

/* show more button */

.footer-link {
  margin-top: 0.5rem;
  font-family: Avenir;
  font-size: 1rem;
  font-weight: bold;
  color: #f5a623;
}

.footer-link > p > span:first-child {
  text-decoration: underline;
}

.load-more-button {
  width: auto;
  font-family: Raleway;
  font-size: 0.8rem;
  font-weight: bold;
  text-align: center;
  letter-spacing: 1px;
  color: #fdfdfd;
  background-color: #f5a623;
  border: 1px solid #f5a623;
  padding: 0.2rem 0.5rem;
  cursor: pointer;
}

.footer-link .icon {
  width: 16px;
  height: 16px;
  margin-left: -2px;
  margin-bottom: 2px;
}

.footer-link:hover {
  cursor: pointer;
}

/* ERROR loading styling */

.error-loading {
  margin: 3rem;
  text-align: center;
}

/* Featured news styling */
.news-article {
  margin: 0rem 0.5rem 1.2rem;
  padding-top: 0.5rem;
  border-top: 1px dashed #4a4a4a;
}

.news-stats {
  border-left: 1px solid #4a4a4a;
  padding-left: 0.5rem;
  margin-bottom: 0.2rem;
}

.icon-lock {
  width: 1rem;
  color: #f5a623;
}

.news-stats > p {
  font-size: 0.8rem;
}

.news-stats > p > span {
  font-weight: bold;
}

.error-loading {
  margin: 3rem;
  text-align: center;
}

.icon-external-link {
  width: 1rem;
  float: right;
  color: black;
  opacity: 0.5;
}

.news-content {
  padding: 0;
}

.news-source {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #4a4a4a;
  font-size: 0.8rem;
  font-style: italic;
}

.news-title {
  color: black;
  font-size: 1rem;
  font-weight: bold;
}

.news-ticker {
  color: #16abbd;
  cursor: pointer;
}

.news-description {
  color: #4a4a4a;
  font-size: 0.8rem;
}

.news-datetime {
  color: #4a4a4a;
  font-size: 0.8rem;
  font-style: italic;
}

@media (min-width: 768px) {
  .news-article {
    margin: 0.5rem 1rem;
    border: none;
  }

  .news-stats {
    padding-top: 1.2rem;
    border: none;
  }

  .news-stats > p {
    border-right: 1px solid #979797;
  }

  .download-data-banner {
    border-left: 1rem solid #16abbd;
  }

  .download-data-banner-title,
  .download-data-banner-link {
    font-size: 1rem;
  }

  .opinion-section-header > h2,
  .opinion-section-header > a {
    font-size: 1.2rem;
  }

  .opinion-publish-date {
    font-size: 0.9rem;
    margin-top: 0;
  }

  .opinion-title,
  .opinion-description {
    font-size: 1rem;
  }

  .error-loading {
    margin: 3.5rem;
  }
}

@media (min-width: 992px) {
  .opinions-section {
    padding-left: 4rem;
    padding-right: 2rem;
  }
  /* Download Data Aside Styling */
  .download-data-aside {
    max-width: 12rem;
    border: 1px solid #16abbd;
    border-top: 1.5rem solid #16abbd;
    padding: 2rem 1rem;
    margin: 2.5rem auto;
  }

  .download-data-aside-title,
  .download-data-aside-link {
    font-family: Raleway;
    font-size: 1.1rem;
    letter-spacing: 1px;
    margin-bottom: 1rem;
  }

  .error-loading {
    margin: 4rem;
  }
}

@media (min-width: 1200px) {
  /* Featured News */
  .featured-section {
    padding: 0 2rem;
  }
  /* Download Data Aside Styling */
  .download-data-aside-wrapper {
    padding-left: 0;
    padding-right: 0;
  }

  .download-data-aside {
    max-width: 15rem;
  }

  .download-data-aside-title > ul {
    list-style: none; /* Remove default bullets */
  }

  .download-data-aside-title > ul > li::before {
    content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
    color: #16abbd; /* Change the color */
    font-weight: bold;
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 1.4em;
    margin-left: -2em;
  }

  .download-data-aside-title > ul > li {
    margin: 0.2rem;
    font-size: 1rem;
  }

  .error-loading {
    margin: 5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/insight-page-components/featured-news.vue